import script from "./SendTestEmailAction.vue?vue&type=script&setup=true&lang=js"
export * from "./SendTestEmailAction.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__